"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var tasks_controller_1 = __importDefault(require("./tasks.controller"));
var tasks_html_1 = __importDefault(require("./tasks.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.tasks", {
        url: "/tasks",
        controller: tasks_controller_1.default,
        controllerAs: "vm",
        template: tasks_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.tasks", [])
    .config(config)
    .controller("AdminStudentViewTasksController", tasks_controller_1.default);
